import { YES_OPTION } from "../constants";
import { getTranslatedCpeBallotOption } from "../lists/ballot";
import { formatYesNoDropdownLists } from "../utils/form-data-utils";

export const formatBallotDataFormValues = (associate, language) => { 
    if(typeof associate.acssData.previousRegistration  !== 'object' && associate.acssData.previousRegistration !== null) {
        associate.acssData.previousRegistration = formatYesNoDropdownLists(associate.acssData.previousRegistration, language);
    }
    else if (typeof associate.acssData.previousRegistration  === 'object' && associate.acssData.previousRegistration !== null) {
        associate.acssData.previousRegistration = formatYesNoDropdownLists(associate.acssData.previousRegistration.code === YES_OPTION.code, language);
    }

    if(typeof associate.acssData.acssBallot  !== 'object' && associate.acssData.acssBallot !== null) {
        associate.acssData.acssBallot = formatYesNoDropdownLists(associate.acssData.acssBallot, language);
    }
    else if (typeof associate.acssData.acssBallot  === 'object' && associate.acssData.acssBallot !== null) {
        associate.acssData.acssBallot = formatYesNoDropdownLists(associate.acssData.acssBallot.code === YES_OPTION.code, language);
    }

    if(typeof associate.acssData.ballotCountryEuEfta  !== 'object' && associate.acssData.ballotCountryEuEfta !== null) {
        associate.acssData.ballotCountryEuEfta = formatYesNoDropdownLists(associate.acssData.ballotCountryEuEfta, language);
    }
    else if (typeof associate.acssData.ballotCountryEuEfta  === 'object' && associate.acssData.ballotCountryEuEfta !== null) {
        associate.acssData.ballotCountryEuEfta = formatYesNoDropdownLists(associate.acssData.ballotCountryEuEfta.code === YES_OPTION.code, language);
    }

    if(typeof associate.acssData.cpeBallot  !== 'object' && associate.acssData.cpeBallot !== null) {
        associate.acssData.cpeBallot = { name: associate.acssData.cpeBallot, code: associate.acssData.cpeBallot };
    }
    else if (typeof associate.acssData.cpeBallot  === 'object' && associate.acssData.cpeBallot !== null) {
        associate.acssData.cpeBallot = getTranslatedCpeBallotOption(associate.acssData.cpeBallot.code, language);
    }

    if(typeof associate.acssData.otherBallot  !== 'object' && associate.acssData.otherBallot !== null) {
        associate.acssData.otherBallot = formatYesNoDropdownLists(associate.acssData.otherBallot, language);
    }
    else if (typeof associate.acssData.otherBallot  === 'object' && associate.acssData.otherBallot !== null) {
        associate.acssData.otherBallot = formatYesNoDropdownLists(associate.acssData.otherBallot.code === YES_OPTION.code, language);
    }

    if(typeof associate.acssData.ballotCountry  !== 'object' && associate.acssData.ballotCountry !== null) {
        associate.acssData.ballotCountry = { name: associate.acssData.ballotCountry, code: associate.acssData.ballotCountry };
    }

    return associate;
}

export const formatBallotDataToService = (associate) => { 

    associate.acssData.previousRegistration = (associate.acssData.previousRegistration.code === YES_OPTION.code);
    associate.acssData.acssBallot = (associate.acssData.acssBallot.code === YES_OPTION.code);
    associate.acssData.ballotCountryEuEfta = (associate.acssData.ballotCountryEuEfta.code === YES_OPTION.code);
    associate.acssData.cpeBallot = (associate.acssData.cpeBallot.code === YES_OPTION.code);
    associate.acssData.otherBallot = (associate.acssData.otherBallot.code === YES_OPTION.code);
    if(associate.acssData.ballotCountry !== null ) associate.acssData.ballotCountry = associate.acssData.ballotCountry.code;
    
    return associate;
}